/**
 * Обучающий слой (07-оболочка-тз, «Обучающий слой»).
 *
 * Отдельный от терминала слой поверх него: другая типографика, вне сетки. Это
 * инструкция к игре, а не игра, и притворяться диегетичной ей не надо —
 * притворство тут хуже прямоты.
 *
 * Экран управления показывается один раз, перед первой комнатой, и дальше живёт
 * клавишей `3`: модалка, исчезнувшая навсегда, — не обучение, первый же
 * отвлёкшийся игрок останется без неё. Командой `управление` он не открывается
 * намеренно — метаинструкция не притворяется действием терминала.
 */

import { ADVANCE_LEGEND, ADVANCE_MARK, EARNED_LEGEND, EARNED_MARK } from './lines.ts';
import { TAP_HINT } from './mode.ts';

const KEYS: [string, string][] = [
  ['↑ ↓', 'выбрать'],
  ['Tab', 'дополнить'],
  ['Enter', 'выполнить'],
  ['Esc', 'очистить ввод'],
  ['1', 'справочник — о чём сейчас речь'],
  ['2', 'дело — слова, которые вы узнали'],
  ['3', 'инвентарь — что у вас с собой'],
  ['?', 'управление'],
  ['0', 'меню — начать заново'],
];

export function Manual({
  first,
  touch = false,
  onDone,
}: {
  first: boolean;
  /** Мобильная версия: экран закрывает касание, и клавиш в нём не обещают. */
  touch?: boolean;
  onDone?: () => void;
}) {
  return (
    <div className="manual" {...(touch && onDone ? { onClick: onDone } : {})}>
      <div className="manual-box">
        {/* Обещать клавиши там, где их нет, нельзя: на телефоне то же самое
            делают касанием, и список хоткеев был бы враньём. */}
        {touch ?
          <>
            <p className="manual-lead">Играют касанием.</p>
            <p>
              Внизу — всё, что сейчас можно сделать. Коснитесь команды, чтобы её выполнить;
              нижняя полоса открывает справочник, дело, инвентарь и меню.
            </p>
          </>
        : <>
            <p className="manual-lead">Игра управляется с клавиатуры. Мыши нет.</p>
            <p>
              Выбирайте команду стрелками или начинайте печатать — строка ввода отфильтрует всё, что
              сейчас можно сделать.
            </p>

            <dl className="manual-keys">
              {KEYS.map(([key, what]) => (
                <div key={key}>
                  <dt>{key}</dt>
                  <dd>{what}</dd>
                </div>
              ))}
            </dl>
          </>
        }

        {/* Та же легенда, что под выбранной командой: игрок не обязан ловить её
            в автокомплите, чтобы узнать, что значит треугольник. */}
        <p className="manual-advance">
          <span className="advance">{ADVANCE_MARK}</span> {ADVANCE_LEGEND}
        </p>

        {/* Смысл звёздочки объясняется ровно здесь и один раз: в списке она
            остаётся значком без подписи, иначе каждая заработанная реплика
            тащила бы за собой объяснение и читалась бы как подсказка. */}
        <p className="manual-advance">
          <span className="earned">{EARNED_MARK}</span> {EARNED_LEGEND}
        </p>

        {/* Не «любая клавиша»: клавиша «дальше» в этой игре одна и та же везде —
            в кадре, в диалоге и здесь. Отдельное правило ради одного экрана
            игрок проверял бы стрелкой или цифрой, то есть ровно тем
            интерфейсом, который экран и объясняет. */}
        <p className="manual-go">
          {touch ? TAP_HINT : 'Enter'} — {first ? 'начать' : 'закрыть'}
        </p>
      </div>
    </div>
  );
}

/**
 * Подсказка-пример — параллельно, а не вместо. Висит поверх терминала в первой
 * комнате и уходит после третьей команды; собственная строка подсказок терминала
 * при этом не меняется никогда.
 *
 * Соблазн подменить её примером надо давить: игрок привыкнет к временному
 * интерфейсу, а потом тот поменяется под ним.
 */
export function Hint({ text }: { text: string }) {
  return <div className="hint">попробуйте: {text}</div>;
}
